import { useEffect, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { DateRangePicker, IRange } from 'features/range-date/date-range-picker'
import { prepareDate } from 'features/range-date/lib'

import { copyFindExcursionsStore } from 'entities/excursions/models/copy-find-excursions/copy-find-excursions-store'
import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'
import { listExcursionStore } from 'entities/excursions/models/list-excursions/list-excursions-state'

import { SearchExcursions } from 'shared/api/excursions'
import { ExcursionById } from 'shared/api/excursions/list/model'
import { SearchCalendar } from 'shared/api/excursions/search/model'
import Loop from 'shared/images/glasss.png'
import { EmptyPage } from 'shared/ui/empty-page'
import { Loader } from 'shared/ui/loader'

import { HeaderCalendar } from './components/header'
import s from './styles.module.scss'

const ExcursionsCalendarRangePage = observer(() => {
  const [params] = useSearchParams()

  const { t } = useTranslation()

  const isSearch = params.get('isSearch')
  const excursionId = params.get('excursion')

  const currentExcursionStore = isSearch
    ? copyFindExcursionsStore
    : findExcursionsStore

  const searchCalendar = currentExcursionStore.findExcursions

  const navigate = useNavigate()

  const [dates, setDates] = useState<string[]>()
  const [loading, setLoading] = useState<boolean>(true)

  const listDates = useRef<ExcursionById[] | null>(null)

  const onRangeDateHandlerDifficult = (data: IRange) => {
    if (excursionId) {
      const results = listDates?.current?.find(
        (date) => date?.departure_date === data.startDate,
      )

      navigate({
        pathname: RoutingPaths.excursion.guideDetail.path(String(results?.id)),
      })
    } else {
      currentExcursionStore.onChangeDepartureDate(data.startDate!)

      navigate(-1)
    }
  }

  const onSearch = async () => {
    if (
      currentExcursionStore.findExcursions.direction ||
      currentExcursionStore?.findExcursions.name
    ) {
      const searchBody: SearchCalendar = {
        direction: searchCalendar.direction,
      }

      if (searchCalendar?.name) {
        searchBody.name = searchCalendar?.name
      }

      try {
        setLoading(true)

        const { data: resultCalendar } =
          await SearchExcursions.calendarDate(searchBody)

        const resultDates = resultCalendar?.data?.map((date) =>
          prepareDate(date.departure_date),
        )

        setDates(resultDates)
      } catch {
        setDates([])
      } finally {
        setLoading(false)
      }
    }
  }

  const getExcursionCalendarById = async (id: string) => {
    try {
      setLoading(true)

      const { data: resultCalendar } =
        await SearchExcursions.calendarFromDate(id)

      const resultDates = resultCalendar?.data?.map((date) =>
        prepareDate(date.departure_date),
      )

      listDates.current = resultCalendar?.data

      setDates(resultDates)
    } catch {
      setDates([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (excursionId) {
      getExcursionCalendarById(excursionId)
    } else {
      onSearch()
    }
  }, [])

  const selectedDate: IRange = {
    startDate: excursionId
      ? listExcursionStore.currentExcursionsDetail?.departure_date
      : currentExcursionStore.findExcursions.departure_date,
  }

  return (
    <div className={s.container}>
      {loading && <Loader marginTop={150} />}

      {!loading && !Boolean(dates?.length) && (
        <div className={s.empty}>
          <EmptyPage
            title={t('excursions.no_excursions')}
            subTitle={t('beket_content.empty_list_description')}
            image={Loop}
          />
        </div>
      )}

      {!loading && Boolean(dates?.length) && (
        <div className={s.contentPop}>
          <DateRangePicker
            difficult
            activeDays={dates}
            selectedDate={selectedDate}
            typeCalendar="excursion"
            focusDate={selectedDate?.startDate}
            onChange={onRangeDateHandlerDifficult}
            header={<HeaderCalendar />}
          />
        </div>
      )}
    </div>
  )
})

export default ExcursionsCalendarRangePage
